import classNames from "classnames";
import { BasicProps } from "./ComponentsInterface";

export const LTitle = ({ ...props }: TitleProps): JSX.Element => {
    const classes = classNames(
        "title",
        props.size ? "is-size-" + props.size : "is-1",
        props.theme === "dark" ? "has-text-white" : props.color ?? "",
        props.verticalSpacing ? `py-${props.verticalSpacing}` : "",
        props.className
    );
    return (
        <h1 style={{ fontSize: props.overrideSize }} className={classes} role="heading">
            {props.children}
        </h1>
    );
};

export interface TitleProps extends BasicProps {
    size?: "1" | "2" | "3" | "4" | "5" | "6" | "7";
    color?: "has-text-dark-blue" | "has-text-primary-blue" | "has-text-danger";
    overrideSize?: "5rem" | "4rem";
    theme?: "dark" | "light";
    verticalSpacing?: "1" | "2" | "3" | "4" | "5" | "6";
    className?: string;
}
